/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2024 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { addTagsModalStyles } from "@monsma/Overrides/Widgets/MyListsDetails/AddTagsModal";
import { css } from "styled-components";

addTagsModalStyles.tagsWrapper = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        max-height: 250px;
        overflow-y: auto;
    `,
};
